import { resource, weeklyCalendar } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getResource(id) {
      const state = getState().find((req) => req.id === id);

      return state
        ? state.resource
        : {
            ...resource,
            uuid: id,
            costProfile: null,
            weeklyCalendar: { ...weeklyCalendar, uuid: "" },
          };
    },
    hasRetrievedResource(id) {
      const state = getState().find((req) => req.id === id);

      return state
        ? state.request.isFailure || state.request.isSuccessful
        : false;
    },
    isResourceRetrievalRequestFailure(id) {
      const state = getState().find((req) => req.id === id);

      return state ? state.request.isFailure : false;
    },
    isResourceRetrievalRequestPending(id) {
      const state = getState().find((req) => req.id === id);

      return state ? state.request.isPending : false;
    },
    isResourceRetrievalRequestSuccess(id) {
      const state = getState().find((req) => req.id === id);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
